import { Component, Ref, Prop } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class CountdownTimer extends ThemeComponent {

    @Ref() daysNumber!: HTMLDivElement;
    @Ref() hoursNumber!: HTMLDivElement;
    @Ref() minutesNumber!: HTMLDivElement;
    @Ref() secondsNumber!: HTMLDivElement;

    @Prop() datetime!: string;

    init() {
        this.renderTimer();
    }

    getTimeRemaining() {
        const total = Date.parse(String(this.datetime)) - Date.parse(String(new Date()));
        const seconds = Math.floor( (total / 1000) % 60 );
        const minutes = Math.floor( (total / 1000 / 60) % 60 );
        const hours = Math.floor( (total / (1000 * 60 * 60)) % 24 );
        const days = Math.floor( total / (1000 * 60 * 60 * 24) );

        return {
            total,
            days,
            hours,
            minutes,
            seconds
        };
    }

    renderTimer() {
        const timeinterval = setInterval(() => {
            const t = this.getTimeRemaining();

            if (t.total > 0) {
                this.daysNumber.innerText = String(t.days);
                this.hoursNumber.innerText = String(t.hours);
                this.minutesNumber.innerText = String(t.minutes);
                this.secondsNumber.innerText = String(t.seconds);
            } else {
                this.renderMessage();
                clearInterval(timeinterval);
            }
        }, 1000);
    }

    renderMessage() {

    }
}
